<template>
  <div>

    <v-row>
      <v-breadcrumbs :items="breadcrumbs" divider=">" style="padding: 12px">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="12" sm="10" md="6">
        <v-row>
          <v-col cols="12">
            <DateTimeSelector
              labelDate="Od"
              :date="form.startDate"
              :time="form.startTime"
              @change="updateStartDateTime"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <DateTimeSelector
              labelDate="Do"
              :date="form.endDate"
              :time="form.endTime"
              @change="updateEndDateTime"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-select
              :items="devices"
              item-text="name"
              item-value="id"
              v-model="form.electronicDeviceId"
              label="Blagajna"
            ></v-select>
            <FormErrors
              v-if="$v.form.$error && (!$v.form.electronicDeviceId.required)"
            >
              <FormErrorsLine v-if="!$v.form.electronicDeviceId.required" text="Polje je obvezno" />
            </FormErrors>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.invoiceNumber"
              label="Številka računa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="auto">
        <v-row>
          <v-col cols="12">
            <v-btn
              color="#0F998E"
              class="white--text mt-2 float-right d-inlineblock"
              @click="search"
            >
              Išči
              <v-icon right dark>fas fa-search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-if="searchComplete">
      <v-row v-if="!invoices.length">
        <v-col>
          V bazi podatkov ni bil najden noben račun za izbrane parametre.
        </v-col>
      </v-row>
      <v-row v-for="invoice in invoices" :key="invoice.id">
        <v-col>
          <ClientsInvoiceCard
            :invoice="invoice"
            :childCompanyId="childCompanyId"
            :businessUnitCode="businessUnitCode"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateTimeSelector from '@/components/DateTimeSelector'
import ClientsInvoiceCard from '@/components/ClientsInvoiceCard'
import { objectToArray } from '@/utils/object'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    ClientsInvoiceCard,
    FormErrors,
    FormErrorsLine,
    DateTimeSelector
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      searchComplete: false,
      form: {
        electronicDeviceId: null,
        invoiceNumber: null,
        startDate: '',
        startTime: '00:00',
        endDate: '',
        endTime: '23:59'
      },
      breadcrumbs: [
        {
          text: 'Stranke',
          disabled: false,
          href: '/clients'
        },
        {
          text: 'Poslovne enote',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/business-units'
        },
        {
          text: 'Furs log',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/business-units/' + this.businessUnitId + '/invoices'
        }
      ]
    }
  },
  validations () {
    return {
      form: {
        electronicDeviceId: {
          required
        }
      }
    }
  },
  computed: {
    businessUnitCode () {
      return this.$store.state.clientsBusinessUnits.items[this.businessUnitId].business_premise_id
    },
    devices () {
      return objectToArray(this.$store.state.clientsDevices.items) // .filter(device => device.activation_date !== null)
    },
    invoices () {
      return objectToArray(this.$store.state.clientsInvoices.items)
    }
  },
  methods: {
    ...mapActions('clientsDevices', { loadDevices: 'loadItems' }),
    ...mapActions('clientsBusinessUnits', { loadBusinessUnits: 'loadItems' }),
    ...mapActions('clientsInvoices', { findInvoices: 'loadItems' }),
    updateStartDateTime ({ date, time }) {
      this.form.startDate = date
      this.form.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.form.endDate = date
      this.form.endTime = time
    },
    search () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.searchComplete = false
        const data = {
          childCompanyId: this.childCompanyId,
          electronicDeviceId: this.form.electronicDeviceId,
          number: this.form.number,
          dateFrom: moment(`${this.form.startDate} ${this.form.startTime}`).format('YYYY-MM-DDTHH:mm:ss'),
          dateTo: moment(`${this.form.endDate} ${this.form.endTime}`).format('YYYY-MM-DDTHH:mm:ss')
        }
        this.findInvoices(data)
          .then(response => {
            this.searchComplete = true
          })
          .catch(anErr => {
            this.searchComplete = true
          })
      }
    }
  },
  created () {
    const today = moment().format('YYYY-MM-DD')
    this.form.startDate = today
    this.form.endDate = today
    Promise.all([
      this.loadDevices({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId }),
      this.loadBusinessUnits({ childCompanyId: this.childCompanyId })
    ])
      .then(response => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
